export const AppRole = {
    OWNER: 'owner',
    ADMIN: 'admin',
    MODERATOR: 'moderator',
    USER: 'user',
};
const RANK = {
    owner: 4,
    admin: 3,
    moderator: 2,
    user: 1,
};
export function isAppRole(value) {
    return value in RANK;
}
export function hasMinAppRole(userRole, required) {
    return RANK[userRole] >= RANK[required];
}
export const APP_ROLE_LABELS = {
    owner: 'Owner',
    admin: 'Admin',
    moderator: 'Moderator',
    user: 'Member',
};
//# sourceMappingURL=app-roles.js.map